
import React from 'react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  MessageSquare,
  Sliders,
  FileText,
  Mic,
  Disc3,
  Sparkles
} from 'lucide-react';

const SidebarTabsList = () => {
  return (
    <TabsList className="grid grid-cols-3 p-2 bg-gradient-to-r from-black/70 to-neon-purple/10 rounded-xl m-2 h-auto gap-2 border border-neon-purple/20 shadow-neon-purple/20">
      <TabsTrigger 
        value="chat" 
        className="py-3 px-3 data-[state=active]:bg-gradient-to-br data-[state=active]:from-neon-purple data-[state=active]:to-neon-blue data-[state=active]:text-white data-[state=active]:shadow-neon data-[state=active]:border-neon-purple/50 rounded-lg transition-all duration-300"
      >
        <div className="flex flex-col items-center gap-1.5">
          <MessageSquare className="h-4 w-4" />
          <span className="text-xs font-medium">Chat</span>
        </div>
      </TabsTrigger>
      
      <TabsTrigger 
        value="mixer" 
        className="py-3 px-3 data-[state=active]:bg-gradient-to-br data-[state=active]:from-neon-purple data-[state=active]:to-neon-blue data-[state=active]:text-white data-[state=active]:shadow-neon data-[state=active]:border-neon-purple/50 rounded-lg transition-all duration-300"
      >
        <div className="flex flex-col items-center gap-1.5">
          <Sliders className="h-4 w-4" />
          <span className="text-xs font-medium">Mixer</span>
        </div>
      </TabsTrigger>
      
      <TabsTrigger 
        value="files" 
        className="py-3 px-3 data-[state=active]:bg-gradient-to-br data-[state=active]:from-neon-purple data-[state=active]:to-neon-blue data-[state=active]:text-white data-[state=active]:shadow-neon data-[state=active]:border-neon-purple/50 rounded-lg transition-all duration-300"
      >
        <div className="flex flex-col items-center gap-1.5">
          <FileText className="h-4 w-4" />
          <span className="text-xs font-medium">Files</span>
        </div>
      </TabsTrigger>
      
      <TabsTrigger 
        value="lyrics" 
        className="py-3 px-3 data-[state=active]:bg-gradient-to-br data-[state=active]:from-neon-purple data-[state=active]:to-neon-blue data-[state=active]:text-white data-[state=active]:shadow-neon data-[state=active]:border-neon-purple/50 rounded-lg transition-all duration-300"
      >
        <div className="flex flex-col items-center gap-1.5">
          <Mic className="h-4 w-4" />
          <span className="text-xs font-medium">Lyrics</span>
        </div>
      </TabsTrigger>
      
      <TabsTrigger 
        value="recordings" 
        className="py-3 px-3 data-[state=active]:bg-gradient-to-br data-[state=active]:from-neon-purple data-[state=active]:to-neon-blue data-[state=active]:text-white data-[state=active]:shadow-neon data-[state=active]:border-neon-purple/50 rounded-lg transition-all duration-300"
      >
        <div className="flex flex-col items-center gap-1.5">
          <Disc3 className="h-4 w-4" />
          <span className="text-xs font-medium">Rec</span>
        </div>
      </TabsTrigger>
      
      <TabsTrigger 
        value="ai" 
        className="py-3 px-3 data-[state=active]:bg-gradient-to-br data-[state=active]:from-neon-purple data-[state=active]:to-neon-blue data-[state=active]:text-white data-[state=active]:shadow-neon data-[state=active]:border-neon-purple/50 rounded-lg transition-all duration-300"
      >
        <div className="flex flex-col items-center gap-1.5">
          <Sparkles className="h-4 w-4" />
          <span className="text-xs font-medium">AI</span>
        </div>
      </TabsTrigger>
    </TabsList>
  );
};

export default SidebarTabsList;
